// extracted by mini-css-extract-plugin
export default {"app":"Loading_app__fcHsX"};